import { useQuery } from '@tanstack/react-query';

import { useTenantStore } from '../../auth/tenantStore';
import type { MeResponse } from '../../auth/types';
import { client } from '../generated/client.gen';

export const meQueryKey = ['me'] as const;

export async function refreshMe(): Promise<void> {
  const { data } = await client.instance.get<MeResponse>('/me');
  useTenantStore.getState().setMe(data);
}

// /me is a bare composite object — not wrapped in { data }.
export function useMe() {
  return useQuery({
    queryKey: meQueryKey,
    queryFn: async (): Promise<MeResponse> => {
      const { data } = await client.instance.get<MeResponse>('/me');
      return data;
    },
  });
}
